module.exports = __webpack_public_path__ + "img/file.4b38f67c.svg";